module.exports = __webpack_public_path__ + "fonts/Gilroy-Heavy.335c7ebf.eot";